import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import CustomerReviewsList from 'components/consumer/customer-reviews-list';
import CustomerReviewsHeader from 'components/consumer/customer-reviews-list/CustomerReviewHeader';
import { Helmet } from 'react-helmet-async';
import { logError } from 'commons/logger';
import { usePrevious } from 'react-use';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_ALL_REVIEWS, GET_REVIEWS_META } from '../../../mocks/queries';
import CustomerReviews from './CustomerReviews';
import withSearchState from './withSearchState';
import { REVIEWS_PAGE_SEO_DESCRIPTION } from '../../../commons/constants';
const CustomerReviewsPage = t0 => {
  const $ = _c(44);
  const {
    config,
    onProduct,
    sortBy,
    searchQuery,
    inSearchMode,
    onSearchUpdate,
    onProductClicked,
    onSortChanged,
    sortSelectOption,
    onProductName
  } = t0;
  const {
    type,
    title,
    subTitle
  } = config;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      name: "reviewsMetaData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: reviewsMetaData
  } = useSuspenseQuery(GET_REVIEWS_META, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      variables: {
        sortBy: "date-desc",
        offset: 0,
        limit: 3
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data,
    error,
    loading,
    refetch,
    fetchMore,
    networkStatus
  } = useSuspenseQuery(GET_ALL_REVIEWS, t2);
  const currentReviewsCount = data?.allReviews?.length ?? 0;
  const totalReviewsCount = reviewsMetaData?.reviewsMeta?.count ?? 0;
  const averageScore = reviewsMetaData?.reviewsMeta?.average_score ?? 0;
  const prevOnProduct = usePrevious(onProduct);
  let t3;
  let t4;
  if ($[2] !== fetchMore || $[3] !== onProduct || $[4] !== prevOnProduct || $[5] !== refetch || $[6] !== sortBy) {
    t3 = () => {
      if (prevOnProduct && !onProduct) {
        refetch({
          sortBy,
          offset: 0,
          limit: 3
        }).then(async () => {
          ;
          try {
            await fetchMore({
              variables: {
                sortBy,
                offset: 0,
                limit: 3
              },
              updateQuery: _temp
            });
          } catch (t5) {
            const err = t5;
            logError(err);
          }
        });
      }
    };
    t4 = [fetchMore, onProduct, prevOnProduct, refetch, sortBy];
    $[2] = fetchMore;
    $[3] = onProduct;
    $[4] = prevOnProduct;
    $[5] = refetch;
    $[6] = sortBy;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Helmet><meta name="description" content={REVIEWS_PAGE_SEO_DESCRIPTION} /><meta property="og:type" content="website" /><meta property="og:title" content="Reviews by Joybird.com" /><meta property="og:description" content={REVIEWS_PAGE_SEO_DESCRIPTION} /><meta property="og:image" content="https://joybird2.imgix.net/meta/jb0916-FacebookPageThumbnails-Reviews-v1.jpg?auto=compress,format" /><meta property="og:url" content="https://joybird.com/reviews/" /></Helmet>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== inSearchMode || $[11] !== onProduct || $[12] !== onProductClicked || $[13] !== onSearchUpdate || $[14] !== searchQuery) {
    t6 = {
      inSearchMode,
      onSearchUpdate,
      onProductClicked,
      searchQuery,
      onProduct
    };
    $[10] = inSearchMode;
    $[11] = onProduct;
    $[12] = onProductClicked;
    $[13] = onSearchUpdate;
    $[14] = searchQuery;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== averageScore || $[17] !== onSortChanged || $[18] !== refetch || $[19] !== sortSelectOption || $[20] !== subTitle || $[21] !== t6 || $[22] !== title || $[23] !== totalReviewsCount || $[24] !== type) {
    t7 = <CustomerReviewsHeader title={title} subTitle={subTitle} type={type} averageScore={averageScore} totalReviewsCount={totalReviewsCount} refetch={refetch} searchState={t6} onSortChanged={onSortChanged} sortSelectOption={sortSelectOption} />;
    $[16] = averageScore;
    $[17] = onSortChanged;
    $[18] = refetch;
    $[19] = sortSelectOption;
    $[20] = subTitle;
    $[21] = t6;
    $[22] = title;
    $[23] = totalReviewsCount;
    $[24] = type;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== averageScore || $[27] !== currentReviewsCount || $[28] !== data?.allReviews || $[29] !== error || $[30] !== fetchMore || $[31] !== loading || $[32] !== networkStatus || $[33] !== onProduct || $[34] !== onProductName || $[35] !== refetch || $[36] !== sortBy || $[37] !== sortSelectOption || $[38] !== totalReviewsCount || $[39] !== type) {
    t8 = !onProduct ? <CustomerReviewsList config={{
      type,
      reviews: data?.allReviews,
      refetch,
      networkStatus,
      loading,
      error,
      loadMore: async () => {
        ;
        try {
          await fetchMore({
            variables: {
              offset: currentReviewsCount,
              sortBy
            },
            updateQuery: _temp2
          });
        } catch (t9) {
          const err_0 = t9;
          logError(err_0);
        }
      },
      totalReviewsCount,
      averageScore
    }} /> : <CustomerReviews id={onProduct} productName={onProductName} forComponent="searchAllReviews" sortBy={sortBy} sortSelectOption={sortSelectOption} />;
    $[26] = averageScore;
    $[27] = currentReviewsCount;
    $[28] = data?.allReviews;
    $[29] = error;
    $[30] = fetchMore;
    $[31] = loading;
    $[32] = networkStatus;
    $[33] = onProduct;
    $[34] = onProductName;
    $[35] = refetch;
    $[36] = sortBy;
    $[37] = sortSelectOption;
    $[38] = totalReviewsCount;
    $[39] = type;
    $[40] = t8;
  } else {
    t8 = $[40];
  }
  let t9;
  if ($[41] !== t7 || $[42] !== t8) {
    t9 = <>{t5}{t7}{t8}</>;
    $[41] = t7;
    $[42] = t8;
    $[43] = t9;
  } else {
    t9 = $[43];
  }
  return t9;
};
export default withSearchState(CustomerReviewsPage);
function _temp(prevResult, t0) {
  const {
    fetchMoreResult
  } = t0;
  return {
    allReviews: [...fetchMoreResult.allReviews]
  };
}
function _temp2(prevResults, t0) {
  const {
    fetchMoreResult: fetchMoreResult_0
  } = t0;
  if (!fetchMoreResult_0) {
    return prevResults;
  }
  return {
    allReviews: [...prevResults.allReviews, ...fetchMoreResult_0.allReviews]
  };
}